<template>

    <div class="relative min-h-screen md:flex">
      
      <Navbar showBack="true" v-if="goBack" />
      <Navbar showBack="false" v-else />

      
      <div class="flex-1 px-4 py-10">
        <div v-if="location_id && !selected_lot_id" class="mb-2">
            <span class="bg-pink-200 text-pink-800 rounded-md shadow-md text-center px-4 py-2 cursor-pointer" @click="resetLocationId()">Change Location</span> <span class="text-pink-700 font-bold px-2">{{location_name}}</span>
        </div>

        <div v-if="location_id && selected_lot_id" class="mb-2">
            <span class="bg-pink-200 text-pink-800 rounded-md shadow-md text-center px-4 py-2 cursor-pointer" @click="resetSelectedLotId()">Change Lot</span> <span class="text-pink-700 font-bold px-2">{{selected_lot_id}}</span>
        </div>
        <SetLocationId v-if="!location_id" @locationid:selected="selectLocationId" @locationname:selected="selectLocationName" />
        <RackLotSearch @lotid:changed="searchLotId" @lotid:selected="selectLotId" v-if="!selected_lot_id && location_id" />
        <ShowLotSearchResult :lot_id="lot_id" v-if="!selected_lot_id && location_id" @lotid:selected="selectLotId" :location_id="location_id" />
        <ExpiryLotForm :lot_id="selected_lot_id" :location_id="location_id" :location_name="location_name" v-if="selected_lot_id && location_id" @lotrack:reset="resetAll" />
      </div>

    </div>
    
</template>

<script>
import Navbar from '../components/Navbar.vue'
import RackLotSearch from '../components/RackLotSearch.vue'
import ShowLotSearchResult from '../components/ShowLotSearchResult.vue'
import ExpiryLotForm from '../components/ExpiryLotForm.vue'
import SetLocationId from '../components/SetLocationId.vue'

export default {
    name: 'SetExpiryLot',
    props: ['passed_location_id', 'passed_selected_lot_id', 'passed_location_name'],
    components: {
        Navbar,
        RackLotSearch,
        ShowLotSearchResult,
        ExpiryLotForm,
        SetLocationId,
    },
    data() {
        return {
            goBack: false,
            lot_id: '',
            selected_lot_id: '',
            location_id: '',
            location_name: '',
            checkin: '',
        }
    },
    methods: {
        searchLotId(lot_id) {
            this.lot_id = lot_id
        },
        selectLotId(lot_id) {
            this.selected_lot_id = lot_id
        },
        selectLocationId(location_id) {
            this.location_id = location_id
        },
        selectLocationName(location_name) {
            this.location_name = location_name
        },
        resetLocationId() {
            this.location_id = ''
            this.location_name = ''
        },
        resetSelectedLotId() {
            this.selected_lot_id = ''
        },
        resetAll() {
            this.selected_lot_id = ''
            this.location_id = ''
            this.location_name = ''
        }
    },
    created() {
        if (!localStorage.hasOwnProperty('api_token')) {
            this.$router.push({ name: 'Login' })
        }

        if (this.passed_location_id && this.passed_selected_lot_id && this.passed_location_name) {
            this.location_id = this.passed_location_id
            this.location_name = this.passed_location_name
            this.selected_lot_id = this.passed_selected_lot_id
        }

        if ((window.history.length - this.$root.historyCount) > 0) {
          this.goBack = true
        }
    },
    mounted() {
        document.title = 'Inventory Count App - Set Lot Expiry'
    }
}
</script>